/**
 * Typing Indicator Component - אינדיקטור הקלדה
 * Shows when assistant is typing
 */

export default function TypingIndicator() {
  return (
    <div className="flex items-start gap-3 mb-4" role="status" aria-live="polite">
      <span className="sr-only">היועץ מקליד...</span>
      <img
        src="/iftach-avatar.jpg"
        alt=""
        aria-hidden="true"
        className="flex-shrink-0 w-10 h-10 rounded-full object-cover border-2 border-primary-200"
      />
      <div className="bg-gray-100 rounded-lg rounded-tr-none p-4 max-w-[80%]">
        <div className="flex items-center gap-1" aria-hidden="true">
          <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
          <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
          <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
        </div>
      </div>
    </div>
  )
}
